import { ApiResult } from 'interfaces/APITypes';

import { ServerSideFilter } from 'components/mytover/invite/UnitUserFilterSection';

import { makeRequest, mytoverInstance } from './client';

export const getUnit = async (serial_number: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/units/${serial_number}`));
};

export const getUnits = async (values?: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/units', { params: values }));
};

export const setUnitName = async (serial_number: string, name: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.patch(`/units/${serial_number}`, { name }));
};

export const getUsersPerUnit = async (serial_number: string, values: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/units/${serial_number}/users`, { params: values }));
};

export const getMyToverAccessBySerialNumber = async (serial_number: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/units/${serial_number}/mytover`));
};

export const getUnitInviteOptions = async (serial: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/units/${serial}/invite-options`));
};

export const getUnitActivity = async (id?: number | string, values?: ServerSideFilter): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/units/${id}/activity`, { params: values }));
};
